import type { SVGProps } from 'react';
export const Remove = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M5.29 15.44c0 .86.7 1.56 1.57 1.56h6.28c.87 0 1.57-.7 1.57-1.56V6.11H5.3zm1.57-7.77h6.28v7.77H6.86zm5.89-3.9L11.96 3H8.04l-.79.78H4.5v1.55h11V3.78z" />
  </svg>
);
